import React, { useEffect } from "react";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import { connect, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { Typography } from "antd";
import { useLocation } from "react-router";
import styled from "styled-components";

import { selectSelectedView, selectUser } from "../store/selector";
import { TableSection } from "../../src/component/TableSection/TableSection";
import ACTIONS from "../store/action";
import { selectedViews } from "../constant/table";
import { WHITE } from "../constant/colors";
import { timeOfDay } from "../utils/date";
import { PendingActions } from "../component/PendingActions";

const { Text, Title } = Typography;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const DashboardScreen = styled.div`
  margin: 0px 15px 0px 15px;
  position: relative;
  background: ${WHITE};
  border-radius: 10px;
  padding: 10px 15px 0px 15px;
`;

const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
`;

const WelcomeHeader = styled.div`
  padding: 30px;
  padding-bottom: 16px;
`;

const DashboardComponent = ({ t, selectedView, setSelectedView }) => {
  let query = useQuery();

  const user = useSelector(selectUser);

  useEffect(() => {
    const currSelectedView = query.get("selectedView");
    if (currSelectedView && Object.values(selectedViews).includes(currSelectedView)) {
      setSelectedView(currSelectedView);
    } else if (!currSelectedView && selectedView) {
      setSelectedView(undefined);
    }
  }, []);

  return (
    <DashboardScreen direction={"vertical"}>
      {!selectedView ? (
        <WelcomeContainer>
          <WelcomeHeader>
            <Title strong>{t("main_title", { timeOfDay: timeOfDay(), firstName: user ? user.firstName : "" })}!</Title>
            <Text style={{ fontSize: "20px" }}>{t("main_subtitle")}</Text>
          </WelcomeHeader>
          <PendingActions />
        </WelcomeContainer>
      ) : (
        <TableSection />
      )}
    </DashboardScreen>
  );
};

const mapStateToProps = createStructuredSelector({
  selectedView: selectSelectedView
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedView: (selectedView) => dispatch(ACTIONS.setSelectedView(selectedView))
});

const Dashboard = compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(DashboardComponent);

export default Dashboard;
